import DashboardRoutes from "../routes/DashboardRoutes";
import BOImagesRoutes from "../routes/BOImagesRoutes";
import FullfillmentCentersRoutes from "../routes/FulfillmentCentersRoutes";
import LabelBrandsRoutes from "../routes/LabelBrandsRoutes";
import StoresRoutes from "../routes/StoresRoutes";
import OrderRoutes from "../routes/OrderRoutes";
import ProductRoutes from "../routes/ProductRoutes";
import BrandsRoutes from "../routes/BrandsRoutes";
import CompaniesRoutes from "../routes/CompaniesRoutes";
import AccountRoutes from "../routes/AccountRoutes";
import BillingRoutes from "../routes/BillingRoutes";
import OtherRoutes from "../routes/OtherRoutes";
import TemplateRoutes from "../routes/TemplateRoutes";
import SalesInsightRoutes from "../routes/SalesInsightRoutes";
import Support from "../routes/SupportRoutes";
import UsersRoutes from "../routes/UsersRoutes";
import BuyingIntelRoutes from "../routes/BuyingIntelRoutes";

export const AllRoutes = [
    ...OtherRoutes,
    ...TemplateRoutes,
    ...DashboardRoutes,
    ...BOImagesRoutes,
    ...FullfillmentCentersRoutes,
    ...LabelBrandsRoutes,
    ...StoresRoutes,
    ...OrderRoutes,
    ...ProductRoutes,
    ...BrandsRoutes,
    ...CompaniesRoutes,
    ...AccountRoutes,
    ...BillingRoutes,
    ...LabelBrandsRoutes,
    ...SalesInsightRoutes,
    ...BuyingIntelRoutes,
    ...Support,
    ...UsersRoutes
];
